import React, { useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import axios from "axios";
import Pagination from "../../../pagination/Pagination";
import Footer from "../footer/Footer";
import Header from "../dashboard/Header";
import SuperAdminLayout from "../SuperAdminLayout";
import { FaFolderOpen } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/esm/Button";
import { message } from "antd";
import LoginRedirection from "../../Service/LoginRedirection";
import TokenUndefined from "../../Service/TokenUndefined";
import Dropdown from "react-bootstrap/Dropdown";
import { Spinner } from "react-bootstrap";
import TableLoader from "../../../common/TableLoader";
import useFetchData from "../../../common/useFetchData";
import FormSuspension from "../../../common/FormSuspension";

const AreaList = () => {
  const [area, setArea] = useState("");
  const [owner, setOwner] = useState("");
  const [staff, setStaff] = useState("");
  const [extra, setExtra] = useState("");
  const [vipGuest1, setVipGuest1] = useState("");
  const [areaError, setAreaError] = useState("");
  const [ownerError, setOwnerError] = useState("");
  const [staffError, setStaffError] = useState("");
  const [vipGuest1Error, setVipGuest1Error] = useState("");
  const [details, setDetails] = useState([]);
  const [id, setId] = useState("");
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  const [editArea, setEditArea] = useState(false);
  // pagination
  const [totalLength, setTotalLength] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [dummyPage, setDummyPage] = useState(1);
  const [category_name, setCategory_name] = useState("");
  const array = ["Exhibitor Company", "Exhibitor Agency"];
  const [isLoading, setIsLoading] = useState(false);
  const [loadingState, setloadingState] = useState(false);
  const [family, setFamily] = useState("");
  const [familyError, setFamilyError] = useState("");
  const [model, setModel] = useState(null);
  const [modelError, setModelError] = useState(null);
  const { showData, error } = useFetchData();
  const [extraError, setExtraError] = useState("");
  const [roomsAllowed, setRoomsAllowed] = useState("");
  const [roomsAllowedError, setRoomsAllowedError] = useState("");

  // function to get request
  const handleSubmit = () => {
    TokenUndefined("superadmin/login");
    const token = localStorage.getItem("jff_token");
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-area`, {
        headers: { token: token },
        params: {
          page: dummyPage,
          limit: limit,
        },
      })
      .then((res) => {
        LoginRedirection(res, "superadmin/login");
        setDetails(res.data.data);
        setloadingState(true);
        // pagination
        setTotalLength(res.data.length);
        setLimit(res.data.limit);
        setPage(res.data.pageNo);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleAreaChange = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z0-9\s\-_./]*$/.test(value)) {
      setArea(value);
      setAreaError("");
    } else {
      setAreaError("Must contain only alphanumeric characters.");
    }
  };

  const handleOwnerChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setOwnerError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setOwner(value);
      setOwnerError("");
    } else {
      setOwnerError("Must contain only numbers.");
    }
  };

  const handleStaffChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setStaffError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setStaff(value);
      setStaffError("");
    } else {
      setStaffError("Must contain only numbers.");
    }
  };

  const handleExtraBadgeChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setExtraError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setExtra(value);
      setExtraError("");
    } else {
      setExtraError("Must contain only numbers.");
    }
  };

  const handleFamilyChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setFamilyError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setFamily(value);
      setFamilyError("");
    } else {
      setFamilyError("Must contain only numbers.");
    }
  };

  const handleVipGuest1Change = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setVipGuest1Error("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setVipGuest1(value);
      setVipGuest1Error("");
    } else {
      setVipGuest1Error("Must contain only numbers.");
    }
  };

  const handleModelChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) <= 0) {
      setModelError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setModel(value);
      setModelError("");
    } else {
      setModelError("Must contain only numbers.");
    }
  };

  const handleRoomsAllowedChange = (e) => {
    const value = e.target.value;
    if (parseFloat(value) < 0) {
      setRoomsAllowedError("Please enter a positive number");
    } else if (/^\d*$/.test(value)) {
      setRoomsAllowed(value);
      setRoomsAllowedError("");
    } else {
      setRoomsAllowedError("Must contain only numbers.");
    }
  };
  useEffect(() => {
    handleSubmit();
  }, [dummyPage, reload]);
  // /get-area

  const handleEdit = () => {
    TokenUndefined("superadmin/login");
    setIsLoading(true);
    if (!area || !String(area).trim()) {
      message.error("Area is Empty");
      setIsLoading(false);
      return;
    }
    if (areaError) {
      message.error(areaError);
      setIsLoading(false);
      return;
    }
    const obj = {
      area: area,
      owner: owner,
      extra: extra,
      staff: staff,
      family: family,
      day_one_guest: vipGuest1,
      category_name,
      model,
      id,
      rooms_allowed: roomsAllowed
    };
    axios
      .post(`${process.env.REACT_APP_API_END_POINT}/update-area`, obj, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        LoginRedirection(res, "superadmin/login");
        window.location.reload(true);
        message.success("Form Submit Successfully");
        setIsLoading(false);
      });
  };

  const handleBack = () => {
    setEditArea(false);
  };

  const handleAreaStatus = (id, status) => {
    TokenUndefined("superadmin/login");
    let setsStatus = "active";
    if (status === "active") {
      setsStatus = "inactive";
    }
    axios
      .post(
        `${process.env.REACT_APP_API_END_POINT}/update-area-status`,
        { id, status: setsStatus },
        {
          headers: {
            token: localStorage.getItem("jff_token"),
          },
        }
      )
      .then((res) => {
        LoginRedirection(res, "superadmin/login");
        setReload(!reload);
      })
      .catch((err) => {
        // LoginRedirection("/superadmin/login");
        if (err.response.status === 401) {
          navigate("/superadmin/login");
          portalAuth.logoutActive();
        }
      });
  };
  return (
    <>
      {editArea && <Header />}
      {editArea && (
        <div>
          <div className="container">
            <div className="text-center">
              <h3 className="form-heading">Edit Area</h3>
            </div>
            <div className="d-flex justify-content-end">
              <Button className="bg-dark" onClick={() => handleBack()}>
                Back
              </Button>
            </div>
            {/* <center> */}
            {showData && showData?.area_edit === "active" ? (
              <div className="form-body-section">
                <div className="form-body">
                  <table className="row">
                    {/* <tr>
                    <td colSpan="3">&nbsp;</td>
                  </tr> */}
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">Area</label>
                      <input
                        onChange={handleAreaChange}
                        className="form-control my-2"
                        type="text"
                        value={area}
                        placeholder="Area"
                        name="area"
                        autocomplete="off"
                        // maxLength={3}
                        // disabled
                      />
                      {areaError && (
                        <span style={{ color: "red" }}>{areaError}</span>
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">Category</label>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="transparent"
                          id="dropdown-basic"
                          className="form-control border my-2"
                        >
                          {category_name ? category_name : "Choose Category"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          className="form-control nodesure"
                          // style={{ overflowY: "scroll", maxHeight: "15vh" }}
                        >
                          {array?.map((item, i) => (
                            <Dropdown.Item
                              key={i}
                              value={item.area}
                              onClick={() => setCategory_name(item)}
                              className="d-flex justify-content-center"
                            >
                              {item}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">Owner</label>
                      <input
                        onChange={handleOwnerChange}
                        className="form-control my-2"
                        required
                        type="text"
                        value={owner}
                        placeholder="Owner"
                        name="owner"
                        autocomplete="off"
                        maxLength={3}
                      />
                      {ownerError && (
                        <span style={{ color: "red" }}>{ownerError}</span>
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">Staff</label>
                      <input
                        onChange={handleStaffChange}
                        className="form-control my-2"
                        required
                        type="text"
                        value={staff}
                        placeholder="Staff"
                        name="staff"
                        autocomplete="off"
                        maxLength={3}
                      />
                      {staffError && (
                        <span style={{ color: "red" }}>{staffError}</span>
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        No. of Extra badges allowed{" "}
                        <font color="#FF0000">*</font>
                      </label>
                      <input
                        onChange={handleExtraBadgeChange}
                        className="form-control my-2"
                        required
                        type="text"
                        value={extra}
                        placeholder="Extra Count"
                        name="extra"
                        autocomplete="off"
                        maxLength={3}
                      />
                      {extraError && (
                        <span style={{ color: "red" }}>{extraError}</span>
                      )}
                    </div>
                    {/*<div className="form-group col-lg-6 col-md-6">
                    <label className="fw-bold">
                      Family
                    </label>
                    <input
                      onChange={handleFamilyChange}
                      className="form-control my-2"
                      required
                      type="text"
                      value={family}
                      placeholder="Family"
                      name="family"
                      autocomplete="off"
                      maxLength={3}
                    />
                    {familyError && (
                      <span style={{ color: "red" }}>{familyError}</span>
                    )}
                  </div> */}
                     <div className="form-group col-lg-6 col-md-6">
                    <label className="fw-bold">Buyer </label>
                    <input
                      onChange={handleVipGuest1Change}
                      className="form-control my-2"
                      required
                      type="text"
                      value={vipGuest1}
                      placeholder="Invited VIP Guest"
                      name="vip_day_1"
                      autocomplete="off"
                      maxLength={3}
                    />
                    {vipGuest1Error && (
                      <span style={{ color: "red" }}>{vipGuest1Error}</span>
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6">
                    <label className="fw-bold">Rooms Allowed</label>
                    <input
                      onChange={handleRoomsAllowedChange}
                      className="form-control my-2"
                      required
                      type="text"
                      value={roomsAllowed}
                      placeholder="Rooms Allowed"
                      name="rooms_allowed"
                      autocomplete="off"
                      maxLength={3}
                    />
                    {roomsAllowedError && (
                      <span style={{ color: "red" }}>{roomsAllowedError}</span>
                    )}
                  </div> 
                    {/* <div className="form-group col-lg-6 col-md-6">
                    <label className="fw-bold">
                      No. of Model <font color="#FF0000">*</font>
                    </label>
                    <input
                      onChange={handleModelChange}
                      className="form-control my-2"
                      required
                      type="text"
                      value={model}
                      placeholder="Model"
                      name="model"
                      autocomplete="off"
                      maxLength={3}
                    />
                    {modelError &&
                      <span style={{ color: "red" }}>{modelError}</span>

                    }
                  </div> */}

                    <div className="form-submit">
                      <Button
                        variant="outline-secondary"
                        type="submit"
                        value="Submit"
                        name="addArea"
                        className="save"
                        onClick={() => handleEdit()}
                      >
                        {isLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </div>
                  </table>
                </div>
              </div>
            ) : (
              <FormSuspension />
            )}
            {/* </center> */}
          </div>
        </div>
      )}

      {loadingState ? (
        !editArea && (
          <SuperAdminLayout title="Area List" count={totalLength}>
            {details.length > 0 ? (
              <>
                <Table
                  responsive
                  className="table table-striped my-3 p-3 data-table"
                >
                  <thead>
                    <tr>
                      <th scope="col">Sr. No.</th>
                      <th scope="col">Area</th>
                      <th scope="col">Owner</th>
                      <th scope="col">Staff</th>
                      <th scope="col">Extra</th>
                      <th scope="col">Buyer</th>
                      <th scope="col">Rooms Allowed</th>
                      <th scope="col">Status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details?.map((data, idx) => {
                      return (
                        <tr key={idx}>
                          <th scope="row">
                            {(dummyPage - 1) * limit + idx + 1}
                          </th>
                          <td>
                            {/^\d+(\.\d+)?$/.test(String(data.area || "").trim())
                              ? `${data.area} Sq Mtrs`
                              : data.area}
                          </td>
                          <td>{data.owner}</td>
                          <td>{data.staff}</td>
                          <td>{data.extra}</td>
                          <td>{data.day_one_guest}</td>
                          <td>{data.rooms_allowed}</td>
                          <td>
                            <Form>
                              <Form.Check
                                type="switch"
                                id={`custom-switch-${idx}`}
                                checked={data.status === "active"}
                                onClick={() => {
                                  handleAreaStatus(data._id, data.status);
                                }}
                              />
                            </Form>
                          </td>
                          <td
                            onClick={() => {
                              setId(data._id);
                              setEditArea(true);
                              setArea(data.area);
                              setAreaError("");
                              setOwner(data.owner);
                              setStaff(data.staff);
                              setExtra(data.extra);
                              setFamily(data.family);
                              setVipGuest1(data.day_one_guest);
                              setModel(data.model);
                              setCategory_name(data.category_name);
                              setRoomsAllowed(data.rooms_allowed);
                            }}
                          >
                            <BiEdit
                              className="pointer-cursor"
                              title={`Edit`}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-end mt-3">
                  <Pagination
                    dummyPage={setDummyPage}
                    totalLength={totalLength}
                    limit={limit}
                    pageNo={page}
                  />
                </div>
              </>
            ) : (
              <div className="crm-empty-state">
                <FaFolderOpen className="crm-empty-icon" />
                <div className="crm-empty-text">No Records Found</div>
                <div className="crm-empty-subtext">There are currently no area records to display.</div>
              </div>
            )}
          </SuperAdminLayout>
        )
      ) : (
        <TableLoader text="Loading area list..." />
      )}
      {editArea && <Footer />}
    </>
  );
};

export default AreaList;
